<template>
  <div class="">
    <section-title content="Información General" :has-line="true" />
    <div class="p-3">
      <div class="mx-2">
        <div class="row">
          <div class="col-md-4">
            <label class="data-title mb-0">Dirección Web:</label>
            <validation-provider
              v-slot="{ errors }"
              name="webAddress"
              rules="url"
            >
              <custom-input
                v-model="model.websiteUrl"
                :custom-error-msg="'La dirección web es inválida.'"
                :error="errors[0]"
                placeholder="www.websitedomain.com"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider
              v-slot="{ errors }"
              name="telephone"
              :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
            >
              <label class="data-title mb-0">Teléfono:</label>
              <custom-input
                v-model="model.phone"
                :custom-error-msg="'El teléfono es requerido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(xxx)xxx-xxxx"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <label class="data-title mb-0">Fax:</label>
            <validation-provider v-slot="{ errors }" name="fax" rules="phone">
              <custom-input
                v-model="model.fax"
                :custom-error-msg="'El fax no es valido.'"
                :error="errors[0]"
                :mask-type="'Phone'"
                placeholder="(xxx)xxx-xxxx"
              />
            </validation-provider>
          </div>
        </div>
        <div v-if="isMedicaidDocumentationWorkflowEnabled" class="row my-2">
          <div class="col-sm-3 my-2">
            <custom-input-display
              v-if="isLocationTypeSchool"
              label="NPI LS DEPR:"
              :value="model.locationSchoolNationalIdentifier"
            />

            <custom-input
              v-else
              v-model="model.locationSchoolNationalIdentifier"
              :disabled="isNpiDisabled"
              label="NPI LS DEPR:"
            />
          </div>

          <div class="col-sm-3 my-2">
            <custom-input
              v-model="model.nationalIdentifier"
              :disabled="isNpiDisabled"
              label="NPI LS Proveedor:"
            />
          </div>
          <div class="col-sm-2 my-2">
            <custom-input
              v-model="model.medicalIdentifier"
              :disabled="isNpiDisabled"
              label="Medicaid ID:"
              maxlength="50"
              placeholder="Ingrese el Medicaid ID"
            />
          </div>

          <div class="row col-sm-4 my-2">
            <div class="col-sm">
              <custom-date-picker
                v-model="model.medicaidDueDate"
                class-container="w-100"
                :disabled="isNpiDisabled"
                format="dd/MMM./yyyy"
                label="Fecha de Vencimiento Medicaid:"
                :min-date="currentDate"
              />
            </div>
            <div class="d-flex" :class="{ 'ml-3': !isNpiDisabled }">
              <div class="mt-4">
                <div v-if="editingNpi">
                  <button
                    v-if="canCancelNpi && initialNpi"
                    class="ab-btn ab-btn-outline-danger mt-1 mr-2"
                    type="button"
                    variant="outline-danger mt-1 mr-2"
                    @click="cancelEditNpi"
                  >
                    <i class="fas fa-times-circle" />
                  </button>

                  <button
                    class="ab-btn ab-btn-success mt-1"
                    type="button"
                    @click="saveNpi"
                  >
                    <i class="fas fa-save " />
                  </button>
                </div>
                <button
                  v-else
                  class="ab-btn ab-btn-success mt-1"
                  type="button"
                  @click="editNpi"
                >
                  <i class="fas fa-edit " />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomInputDisplay from 'CustomInputDisplay';
import { ValidationProvider } from 'vee-validate';
import CustomDatePicker from 'custom-date-picker';
export default {
  name: 'LocationServiceGeneralInfo',
  components: {
    SectionTitle,
    CustomInput,
    ValidationProvider,
    CustomInputDisplay,
    CustomDatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isMedicaidDocumentationWorkflowEnabled: {
      type: Boolean,
      default: false,
    },
    isLocationTypeSchool: {
      type: Boolean,
      default: false,
    },
    initialNpi: {
      type: String,
      default: '',
    },
    initialNpiDepr: {
      type: String,
      default: '',
    },
    initialMedicalIdentifier: {
      type: String,
      default: '',
    },
    initialMedicaidDueDate: {
      type: Date,
      default: '',
    },
  },
  data() {
    return {
      editingNpi: false,
      canCancelNpi: false,
      canCancelNpiDepr: false,
    };
  },
  watch: {
    initialNpi: {
      immediate: true,
      handler(val) {
        this.editingNpi = !val;
      },
    },
  },
  computed: {
    currentDate() {
      return new Date();
    },
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isNpiDisabled() {
      return !this.editingNpi && !!this.initialNpi;
    },
    isSomePhoneFilledUp() {
      const phone = Boolean(this.model.phone);
      const fax = Boolean(this.model.fax);
      return fax || phone;
    },
  },
  methods: {
    editNpiDepr() {
      this.canCancelNpiDepr = true;
    },
    editNpi() {
      this.editingNpi = true;
      this.canCancelNpi = true;
    },
    cancelEditNpi() {
      this.model.nationalIdentifier = this.initialNpi || '';
      this.model.locationSchoolNationalIdentifier = this.initialNpiDepr;
      this.model.medicalIdentifier = this.initialMedicalIdentifier;
      this.model.medicaidDueDate = this.initialMedicaidDueDate;
      this.editingNpi = false;
    },
    async saveNpi() {
      this.$emit('save-npi', this.model, () => {
        this.editingNpi = false;
      });
    },
  },
};
</script>
